import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import { remove, reverse } from 'lodash';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import {
  MainDisplayFlex,
  MainHead,
  Content,
  BalanceSummaryWrap,
  SubHead,
  FundId,
  BalanceValue,
  ImageWrap,
  AccountWrap,
  DisplayFlex,
  FlexCenter,
  DocCentreContentWrapper,
  FixedWidthSpace,
  LoaderContainer,
  ItlicText,
  Border
} from "./styles";
import CollapseComponent from "./../Components/CollapseComponent/CollapseComponent";
import minimize from './../../../assets/icons/close-accordion.svg';
import maximize from './../../../assets/icons/open-accordion.svg';
import { fetchTransactionalDetails, filterGridData, filterSort, radioValueUpdate, fetchTransactionalTabDetails, tabChangerHandler } from "./actions"
import MultiSelect from "./../Components/MultiSelect/MultiSelect.js";
import { FixedWidth } from "./../../../CommonComponents/commonStyles";
import Calender from "./../Components/DateTimepicker/Calender";
import { getTransactionApi } from "./config";
import { todayDate } from '../../../utils/commonUtil'
import { getPrimaryAccount } from '../../../utils/sessionUtil'
import BreadcrumbComponent from "./../../../CommonComponents/Breadcrumb/Breadcrumb"
import formatter from './../../../utils/formatter';
import Preloader from "./../../../CommonComponents/Preloader/Preloader";
import { tabNameHandler } from "./../Pages/txnUitls";
import { ContentProvider, Types, ContentMessage } from "./../../../CommonComponents/ContentMessages";
import BalanceSummaryItem from '../Components/BalanceSummaryItem';
import PendingAlerts from "../../AccountSummary/Pages/Component/PendingAlerts/PendingAlerts";
import { Row } from "antd";

export class TransactionSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      TransactionalIcon: window.screen.width > 767 ? minimize : maximize,
      BalanceIcon: window.screen.width > 767 ? minimize : maximize,
      FeeIcon: window.screen.width > 767 ? minimize : maximize,
      visible: false,
      filterMinDate: `01/01/${moment(todayDate()).year()}`,
      filterMaxDate: todayDate(),
      selectedVal: [`${moment(todayDate()).year()}`],
      radioValue: {
        Contributions: 'tradeDate',
        Grants: 'tradeDate',
        Exchanges: 'tradeDate',
        OtherTransactions: 'tradeDate',
        AllTransactions: 'tradeDate'
      },
      isCustom: false,
      dropdownYearsValue: [
        `${moment(todayDate()).year()}`,
      ],
      isOpen: {
        transactionalDetails: (window.screen.width > 767),
        balanceHistory: (window.screen.width > 767),
        fees: (window.screen.width > 767),
      },
      dropdownValue: [
        "All",
        "Custom Dates",
        "2019",
      ],
      isContainNonVGPool: false
    };
    this.pageTitle = 'Transaction Summary';
  }

  componentWillMount() {
    const { tab } = queryString.parse(this.props.location.search);
    if (tab === 'otherTransactions') {
      this.props.tabChangerHandler("5");
    }
    else
    {
      this.props.tabChangerHandler("1");
    }
    let txnSessionData = sessionStorage.getItem("transactionSummary");
    if (txnSessionData) {
      let txnFilterData = JSON.parse(txnSessionData);
      let customDateValue = txnFilterData.filterMinDate + ' - ' + txnFilterData.filterMaxDate + " Custom Dates";
      if (txnFilterData.selectedVal) {
        this.setState({
          selectedVal: txnFilterData.isCustom ? [customDateValue] : txnFilterData.selectedVal,
          filterMinDate: txnFilterData.filterMinDate,
          filterMaxDate: txnFilterData.filterMaxDate,
        })
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.radioValueUpdate(this.state.radioValue);
    const { tab } = queryString.parse(this.props.location.search);
    if (tab === 'otherTransactions') {
      this.fetchDetailsData("5");
    } else {
      this.fetchDetailsData();
    }
  };

  componentWillReceiveProps(nextProps) {
    const tabName = tabNameHandler(nextProps.activeTabKey)
    this.checkNonVGPoolExist();
    let filterData = {
      startDate: this.state.filterMinDate,
      endDate: this.state.filterMaxDate,
      isTradeDate: !(this.state.radioValue[tabName.tabType] === 'enteredDate'),
      tabTransactionalData: nextProps.tabTransactionalData,
      transactionalDetails: nextProps.transactionalDetails ? nextProps.transactionalDetails.toJS(): {},
      balanceDetails: nextProps.balanceDetails,
      selectedVal: this.state.selectedVal,
      tabName: tabName
    }
    this.props.filterSort(filterData)
    if (nextProps.accountDetail && nextProps.accountDetail.yearWiseBalance && nextProps.accountDetail.yearWiseBalance.length > 0) {
      let dropdownYearsValue = nextProps.accountDetail.yearWiseBalance.map(accYear => accYear.year);
      dropdownYearsValue = reverse(dropdownYearsValue);
      let dropdownValue = ["All", "Custom Dates"].concat(dropdownYearsValue);
      this.setState({
        dropdownValue,
        dropdownYearsValue
      })
    }
    this.getYearsList()
  }

  componentWillUnmount() {
    let txnSessionData = {
      selectedVal: this.state.selectedVal,
      filterMinDate: this.state.filterMinDate,
      filterMaxDate: this.state.filterMaxDate,
      isCustom: this.state.isCustom
    };
    sessionStorage.setItem("transactionSummary", JSON.stringify(txnSessionData));
  }

  checkNonVGPoolExist = () => {
    const { accountData } = this.props;
    if(accountData.investmentPools) {
      this.setState({ isContainNonVGPool: accountData.investmentPools.some((pools)=> (pools.poolName.includes('TIFF Multi-Asset') || pools.poolName.includes('Low Carbon Global')))})
    }
  }

  fetchDetailsData = (otherTab) => {
    const tabName = tabNameHandler(otherTab || this.props.activeTabKey);
    let apiData = {
      startDate: this.state.filterMinDate,
      endDate: this.state.filterMaxDate,
      isTradeDate: !(this.state.radioValue[tabName.tabType] === 'enteredDate'),
      type: tabName.apiType,
      selectedVal: this.state.selectedVal
    };
    this.props.fetchTransactionalDetailsData(getTransactionApi(apiData));
  }

  getYearsList = () => {
    let dt = new Date();
    let thisYear = dt.getFullYear();
    let yearsValue = [];
    if (this.props.originalOpenDate) {
      const originalOpenDate = this.props.originalOpenDate;
      let establishedYear = moment(originalOpenDate).year();
      if (establishedYear < thisYear) {
        for (let i = establishedYear; establishedYear <= thisYear; establishedYear++) {
          yearsValue.push(establishedYear.toString())
        }
      } else {
        yearsValue.push(thisYear.toString())
      }
    } else {
      yearsValue.push(thisYear.toString())
    }
    yearsValue = reverse(yearsValue);
    this.setState({
      dropdownYearsValue: yearsValue,
      dropdownValue: ["All", "Custom Dates"].concat(yearsValue)
    });
  }

  handleChange = icon => {
    let isOpen = this.state.isOpen;
    switch (icon) {
      case 'TransactionalIcon':
        isOpen.transactionalDetails = !this.state.isOpen.transactionalDetails;
        break;
      case 'BalanceIcon':
        isOpen.balanceHistory = !this.state.isOpen.balanceHistory;
        break;
      case 'FeeIcon':
        isOpen.fees = !this.state.isOpen.fees;
        break;
      default:
    }
    this.setState({
      isOpen,
      show: !this.state.show,
      [icon]: `${this.state[icon] === maximize ? minimize : maximize}`
    });
  };

  radioChange = (e, type) => {
    let prevState = this.state;
    prevState.radioValue[type] = e.target.value;
    let apiType = 'contributions'
    switch (type) {
      case 'Grants':
        apiType = 'grants'
        break;
      case 'Exchanges':
        apiType = 'exchanges'
        break;
      case 'OtherTransactions':
        apiType = 'otherTransactions'
        break;
      case 'AllTransactions':
        apiType = 'all'
        break;
      default:
        apiType = 'contributions'
        break;
    }
    this.setState(
      prevState,
      () => {
        this.props.radioValueUpdate(this.state.radioValue)
        let apiData = {
          startDate: this.state.filterMinDate,
          endDate: this.state.filterMaxDate,
          isTradeDate: !(this.state.radioValue[type] === 'enteredDate'),
          type: apiType,
          selectedVal: this.state.selectedVal
        }
        this.props.fetchTransactionalTabDetailsData(getTransactionApi(apiData));
      });
  };

  filterDataOnYear = (years) => {
    let today = todayDate()
    let preState = this.state;
    let newYear = years;
    let filterShowYear = this.state.selectedVal;
    switch (years[years.length - 1]) {
      case 'All':
        newYear = ['All']
        filterShowYear = ['All']
        break;
      case 'Custom Dates':
        newYear = ['Custom Dates']
        preState.visible = true;
        break;
      default:
        newYear = remove(years, function (n) {
          return (n !== 'All' && n.indexOf('Custom Dates') === -1);
        })
        filterShowYear = newYear;
        break;
    }
    if (newYear.length === 1) {
      if (newYear[0] === 'All') {
        preState.filterMaxDate = today;
        preState.filterMinDate = '01/01/' + Math.min(...preState.dropdownYearsValue);
      }
      if (newYear[0] !== 'All' && newYear.indexOf('Custom Dates') === -1) {
        preState.filterMaxDate = moment(today, "MM/DD/YYYY") >= moment('12/31/' + Math.max(...newYear), "MM/DD/YYYY") ? '12/31/' + Math.max(...newYear) : today
        preState.filterMinDate = '01/01/' + newYear
      }
    } else if (newYear.length > 1) {
      preState.filterMinDate = '01/01/' + Math.min(...newYear)
      preState.filterMaxDate = moment(today, "MM/DD/YYYY") >= moment('12/31/' + Math.max(...newYear), "MM/DD/YYYY") ? '12/31/' + Math.max(...newYear) : today
    }
    if (newYear.length < 1) {
      preState.filterMaxDate = today;
      preState.filterMinDate = '01/01/' + Math.min(...preState.dropdownYearsValue);
    }
    preState.selectedVal = filterShowYear;
    preState.isCustom = false;
    this.setState(preState, () => {
      if (years[years.length - 1] !== 'Custom Dates') {
        this.fetchDetailsData();
      }
    })
  }

  filterOnCustomDate = (dates) => {
    let convertDates = []
    let dateFormate = ''
    if (dates.length === 1) {
    } else if (dates.length > 1) {
      for (let i = 0; i < dates.length; i++) {
        dateFormate = dates[i].split('-').join('/')
        convertDates.push(new Date(dateFormate))
      }
      var minDate = new Date(Math.min.apply(null, convertDates));
      var maxDate = new Date(Math.max.apply(null, convertDates));
      let customDateValue = moment(minDate).format('MM/DD/YYYY') + ' - ' + moment(maxDate).format('MM/DD/YYYY') + " Custom Dates";
      let selectedVal = [customDateValue];
      this.setState({
        selectedVal,
        filterMinDate: moment(minDate).format('MM/DD/YYYY'),
        filterMaxDate: moment(maxDate).format('MM/DD/YYYY'),
        visible: false,
        isCustom: true
      }, () => {
        this.fetchDetailsData();
      })
    }
  }

  breadcrumbRoutes = () => {
    return [
      {
        routeName: 'Home',
        path: '/'
      },
      {
        routeName: 'My Account',
        path: '/my-account'
      },
      {
        routeName: 'Transaction Summary',
        path: ''
      }
    ];
  };

  handleCancel = (e) => {
    this.setState({ visible: false })
  };

  startDateFunc = (date) => {
    this.setState({ filterMinDate: date })
  }

  endDateFunc = (date) => {
    this.setState({ filterMaxDate: date })
  }

  setTitle = (title) => {
    this.pageTitle = title;
  }

  render() {
    let visible = this.state.visible;
    let { isContainNonVGPool } = this.state;
    const { accountDetails } = this.props;
    return (
      <ContentProvider types={[Types.PAGE_TITLE_DESCRIPTION]} pages={['Transaction Summary']}>
        <FixedWidth>
          <div className="fluid" data-test='transactionSummary'>
            <FixedWidthSpace>
              <BreadcrumbComponent breadcrumbRoutes={this.breadcrumbRoutes()} />
            </FixedWidthSpace>
            <MainDisplayFlex marginBottom="30px">
              <div className="relative">
                <MainHead marginBottom="30px" MmarginBottom="22px">
                  <ContentMessage
                    page='Transaction Summary'
                    type={Types.PAGE_TITLE_DESCRIPTION}
                    property='field_page_title'
                    defaultMessage={<Preloader styling="btnLoader"/>}
                    setTitle={this.setTitle}
                  />
                </MainHead>
                <AccountWrap>
                  <Content marginBottom="1px">
                    {getPrimaryAccount() && getPrimaryAccount().accountName ? getPrimaryAccount().accountName : null}
                  </Content>
                  <FundId>
                    {getPrimaryAccount().accountNumber ? getPrimaryAccount().accountNumber : null}
                  </FundId>
                </AccountWrap>
                <FlexCenter marginTop="30px" marginBottom="25px" spaceBetween="flex-start">
                  <DocCentreContentWrapper marginRight='20px'>
                    Filter by </DocCentreContentWrapper>
                  <MultiSelect selectedVal={this.state.selectedVal} options={this.state.dropdownValue} handleDropper={this.filterDataOnYear} />
                  <Calender
                    style={{ width: 200 }}
                    visible={visible}
                    onCancel={this.handleCancel}
                    onFilterClick={this.filterOnCustomDate}
                    filterMinDate={this.state.filterMinDate}
                    filterMaxDate={this.state.filterMaxDate}
                    startDate={this.startDateFunc}
                    endDate={this.endDateFunc}
                  >
                    Select TimeFrame
                  </Calender>
                </FlexCenter>
              </div>
              <BalanceSummaryWrap>
                <SubHead
                  MmarginBottom="10px"
                  MpaddingBottom="10px"
                  marginBottom="8px"
                  borderBottom="1px solid #d4d4d4"
                  paddingBottom="5px"
                >
                  Balance Summary* 
                </SubHead>
                <BalanceSummaryItem title="Beginning Balance" balanceSummaryValue={accountDetails && accountDetails.beginning} />
                <BalanceSummaryItem title="Contributions" balanceSummaryValue={accountDetails && accountDetails.contribution.amount} />
                <BalanceSummaryItem title="Grants" balanceSummaryValue={accountDetails && accountDetails.grant.amount} />
                <BalanceSummaryItem title="Exchanges" balanceSummaryValue={accountDetails && accountDetails.exchange.amount} />
                <BalanceSummaryItem title="Other transactions" balanceSummaryValue={accountDetails && accountDetails.other.amount} />
                <BalanceSummaryItem title={`Market movement${isContainNonVGPool ? '**': '' }`} balanceSummaryValue={accountDetails && accountDetails.marketMovement} />
                <BalanceSummaryItem title="Ending Balance" balanceSummaryValue={accountDetails && accountDetails.ending} />
                <Border />
                <div>
                  <ItlicText>* Based on Trade Date</ItlicText> 
                  { isContainNonVGPool &&  <ItlicText>** Recent balance and market movement details are subject to change due to non-Vanguard options. Outside investments are reported on a two day delay</ItlicText>}
                </div>
              </BalanceSummaryWrap>
            </MainDisplayFlex>
          {!this.props.transactionalDetailsisLoading && this.props.transSummaryBanner && <Row> <PendingAlerts
              account_data = { this.props.transSummaryBanner}
              pageName = { "TS" }
            /> </Row>
            }
            {
              (this.props.transactionalDetails && !this.props.transactionalDetailsisLoading)
                ?
                <CollapseComponent
                  handleChange={() => this.handleChange("TransactionalIcon")}
                  radioChange={this.radioChange}
                  radioValue={this.state.radioValue}
                  accordionkey="1"
                  pageTitle={this.pageTitle}
                  isOpen={this.state.isOpen.transactionalDetails}
                  filterMaxDate={this.state.filterMaxDate}
                  filterMinDate={this.state.filterMinDate}
                  selectedVal={this.state.selectedVal}
                  details={this.props.transactionalDetails.data}
                  dropdownValue={this.state.dropdownValue}
                  title={
                    <DisplayFlex>
                      <SubHead marginBottom="0px">Transactional Details</SubHead>
                      <ImageWrap className="collapsePlus_Minus" src={this.state.TransactionalIcon} alt="plus" />
                    </DisplayFlex>
                  }
                />
                :
                <LoaderContainer>
                  <Preloader />
                </LoaderContainer>
            }
            {
              (this.props.balanceDetails && !this.props.balanceDetailsisLoading)
              &&
              <CollapseComponent
                handleChange={() => this.handleChange("BalanceIcon")}
                accordionkey="2"
                pageTitle={this.pageTitle}
                isOpen={this.state.isOpen.balanceHistory}
                filterMaxDate={this.state.filterMaxDate}
                filterMinDate={this.state.filterMinDate}
                selectedVal={this.state.selectedVal}
                details={this.props.balanceDetails}
                dropdownValue={this.state.dropdownValue}
                title={
                  <DisplayFlex>
                    <SubHead marginBottom="0px">Account balance history</SubHead>
                    <ImageWrap className="collapsePlus_Minus" src={this.state.BalanceIcon} alt="plus" />
                  </DisplayFlex>
                }
              />
            }
            {
              (this.props.feeAndExpenses && this.props.feeContent && !this.props.transactionalDetailsisLoading)
              &&
              <CollapseComponent
                handleChange={() => this.handleChange("FeeIcon")}
                accordionkey="3"
                pageTitle={this.pageTitle}
                isOpen={this.state.isOpen.fees}
                filterMaxDate={this.state.filterMaxDate}
                filterMinDate={this.state.filterMinDate}
                selectedVal={this.state.selectedVal}
                details={this.props.feeAndExpenses}
                dropdownValue={this.state.dropdownValue}
                title={
                  <DisplayFlex>
                    <SubHead marginBottom="0px">Fees &amp; Expenses</SubHead>
                    <ImageWrap className="collapsePlus_Minus" src={this.state.FeeIcon} alt="plus" />
                  </DisplayFlex>
                }
              />
            }
          </div>
        </FixedWidth>
      </ContentProvider>
    );
  }
}

TransactionSummary.propTypes = {
  accountDetails: PropTypes.object,
  transactionalDetails: PropTypes.object,
  transactionalDetailsisLoading: PropTypes.bool,
  tabTransactionalData: PropTypes.object,
  balanceDetails: PropTypes.object,
  balanceDetailsisLoading: PropTypes.bool,
  feeAndExpenses: PropTypes.object,
  feeContent: PropTypes.object,
  activeTabKey: PropTypes.string,
  fetchTransactionalDetailsData: PropTypes.func.isRequired,
  fetchTransactionalTabDetailsData: PropTypes.func.isRequired,
  updateFilterData: PropTypes.func.isRequired,
  filterSort: PropTypes.func.isRequired,
  radioValueUpdate: PropTypes.func.isRequired,
  tabChangerHandler: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  accountDetails: state.getIn(["transactionSummary", "accountDetails", "data"]),
  transactionalDetails: state.getIn(["transactionSummary", "transactionalDetails"]),
  transactionalDetailsisLoading: state.getIn(["transactionSummary", "transactionalDetails", "isLoading"]),
  tabTransactionalData: state.getIn(["transactionSummary", "tabTransactionalData"]),
  balanceDetails: state.getIn(["transactionSummary", "balanceDetails", "data"]),
  balanceDetailsisLoading: state.getIn(["transactionSummary", "balanceDetails", "isLoading"]),
  feeAndExpenses: state.getIn(["transactionSummary", "feeAndExpenses", "data"]),
  feeContent: state.getIn(["transactionSummary", "feeContent", "data"]),
  originalOpenDate: state.getIn(["messaging", "messages", "additionalAccountDetails", "originalOpenDate"]),
  activeTabKey: state.getIn(["transactionSummary", "activeTabKey"]),
  accountData: state.getIn(["accountSummary", "account_data", "data"]),
  transSummaryBanner: state.getIn(["transactionSummary", "transactionalDetails", "data", "allData","accountBannerFlag"])
});

export const mapDispatchToProps = dispatch => ({
  fetchTransactionalDetailsData: data => dispatch(fetchTransactionalDetails(data)),
  fetchTransactionalTabDetailsData: data => dispatch(fetchTransactionalTabDetails(data)),
  updateFilterData: data => dispatch(filterGridData(data)),
  filterSort: data => dispatch(filterSort(data)),
  radioValueUpdate: (value) => dispatch(radioValueUpdate(value)),
  tabChangerHandler: (key) => dispatch(tabChangerHandler(key))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TransactionSummary)
);
